module.exports = __webpack_public_path__ + "static/media/icon_north.e233aa16.svg";